import styled from "@emotion/styled";
import { getComponentFromPath } from "@kaltura/mediaspace-shared-utils";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { Suspense } from "react";

export interface ActionButtonsProps {
    className?: string;
    actionButtons?: KmsTypeComponent[];
    isForEmptyState?: boolean;
}

/**
 * Render action buttons for the channel/gallery view page, i.e. "add to channel"
 */
export const ActionButtons = ({ className = "", actionButtons = [], isForEmptyState }: ActionButtonsProps) => {
    if (actionButtons.length === 0) {
        return null;
    }

    return (
        <StyledActionButtons className={`${className} kms-ds-channel-page-actions-buttons`}>
            {actionButtons.map((action) => {
                const Component = getComponentFromPath(action.component);
                return (
                    <ErrorBoundary key={action.name} fallback={<></>}>
                        <Suspense fallback={<></>}>
                            <Component {...action.props} isForEmptyState={isForEmptyState} />
                        </Suspense>
                    </ErrorBoundary>
                );
            })}
        </StyledActionButtons>
    );
};

const StyledActionButtons = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    flexGrow: 0,
    flexShrink: 0,
}));
